<form *ngIf="formGroup else loadingIndicator" [formGroup]="formGroup">
    <nuc-form-field label="Type">
        <nuc-dropdown formControlName="type"
                      [nullOption]="false"
                      [total]="actionTypeOptions.length"
                      [items]="actionTypeOptions"
                      placeholder="Select an action type">
        </nuc-dropdown>
    </nuc-form-field>

    <nuc-form-field label="Name">
        <nuc-dropdown formControlName="name"
                      [nullOption]="false"
                      [searchable]="true"
                      (requestData)="searchNames($event)"
                      [total]="nameOptions.length"
                      [items]="nameOptions"
                      placeholder="Select an action name">
        </nuc-dropdown>
    </nuc-form-field>

    <nuc-form-field label="Title">
        <nuc-input formControlName="title" placeholder="Enter title"></nuc-input>
    </nuc-form-field>

    <nuc-form-field label="Transition" *ngIf="formGroup.controls.transition">
        <nuc-dropdown formControlName="transition"
                      [nullOption]="false"
                      [searchable]="true"
                      (requestData)="searchTransitions($event)"
                      [total]="transitionOptions.length"
                      [items]="transitionOptions"
                      placeholder="Select a transition">
        </nuc-dropdown>
    </nuc-form-field>

    <nuc-form-field label="Icon">
        <nuc-dropdown formControlName="icon"
                      [nullOption]="false"
                      [searchable]="true"
                      (requestData)="searchIcons($event)"
                      [total]="nucIconOptions.length"
                      [items]="nucIconOptions"
                      placeholder="Select an icon">
        </nuc-dropdown>
    </nuc-form-field>

    <nuc-form-field label="Permissions">
        <nuc-dropdown-multiselect
            formControlName="permissions"
            [items]="permissions"
            placeholder="Select permissions">
        </nuc-dropdown-multiselect>
    </nuc-form-field>

    <nuc-form-field label="Note status from" *ngIf="formGroup.controls.from">
        <nuc-dropdown-multiselect formControlName="from"
                                  [items]="noteFromStatus"
                                  placeholder="Select note status from">
        </nuc-dropdown-multiselect>
    </nuc-form-field>

    <nuc-form-field label="Note status to" *ngIf="formGroup.controls.to">
        <nuc-dropdown formControlName="to"
                      [total]="noteToStatus.length"
                      [items]="noteToStatus"
                      placeholder="Select note status to">
        </nuc-dropdown>
    </nuc-form-field>

    <div *ngIf="formGroup.controls.options" class="options-form">
        <h2>Action options</h2>
        <p>Set the options for the action</p>

        <hr />

        <form [formGroup]="optionsFormGroup">

            <ng-container *ngFor="let control of optionsFormGroup.controls | keyvalue">
                <ng-container [ngSwitch]="control.key">
                    <div *ngSwitchCase="EWorkflowActionOptionName.ADD_PACKAGE_DATA" class="boolean-field">
                        <nuc-form-field label="Add package data"></nuc-form-field>
                        <!--text and textPosition is used to fix styling-->
                        <nuc-checkbox [formControlName]="control.key" text=" " textPosition="start"></nuc-checkbox>
                    </div>

                    <div *ngSwitchCase="EWorkflowActionOptionName.ADD_NOTES" class="boolean-field">
                        <nuc-form-field label="Add notes"></nuc-form-field>
                        <!--text and textPosition is used to fix styling-->
                        <nuc-checkbox [formControlName]="control.key" text=" " textPosition="start"></nuc-checkbox>
                    </div>

                    <div *ngSwitchCase="EWorkflowActionOptionName.AUTO_ASSIGN" class="boolean-field">
                        <nuc-form-field label="Auto assign"></nuc-form-field>
                        <!--text and textPosition is used to fix styling-->
                        <nuc-checkbox [formControlName]="control.key" text=" " textPosition="start"></nuc-checkbox>
                    </div>

                    <div *ngSwitchCase="EWorkflowActionOptionName.ADD_FOR_RELATED_PUBLICATION_ITEMS" class="boolean-field">
                        <nuc-form-field label="Add to related publication items"></nuc-form-field>
                        <!--text and textPosition is used to fix styling-->
                        <nuc-checkbox [formControlName]="control.key" text=" " textPosition="start"></nuc-checkbox>
                    </div>

                    <div *ngSwitchCase="EWorkflowActionOptionName.DISPLAY" class="dropdown-field">
                        <!--Use formControl instead of formControlName here, to avoid formControl reference to get lost/confused-->
                        <nuc-form-field label="Choose the display properties from the campaign item" *ngIf="displayType === EWorkflowActionOptionDisplayType.MULTI">
                            <nuc-dropdown-multiselect [formControl]="optionsFormGroup.controls[control.key]"
                                                      [items]="displayOptions"
                                                      placeholder="Select display properties">
                            </nuc-dropdown-multiselect>
                        </nuc-form-field>

                        <nuc-form-field label="Choose the display property from the campaign item" *ngIf="displayType === EWorkflowActionOptionDisplayType.SINGLE">
                            <nuc-dropdown [formControl]="optionsFormGroup.controls[control.key]"
                                          [items]="displayOptions"
                                          placeholder="Select display property">
                            </nuc-dropdown>
                        </nuc-form-field>
                    </div>

                    <div *ngSwitchCase="EWorkflowActionOptionName.CAMPAIGN_ITEM_FIELDS" class="dropdown-field">
                        <nuc-form-field label="Choose the display properties from the campaign item">
                            <nuc-dropdown-multiselect [formControlName]="control.key"
                                                      [items]="campaignItemFieldOptions"
                                                      placeholder="Select display properties">
                            </nuc-dropdown-multiselect>
                        </nuc-form-field>
                    </div>

                    <div *ngSwitchCase="EWorkflowActionOptionName.PACKAGES" [formGroupName]="control.key">
                        <nuc-form-field label="Select package types">
                            <nuc-dropdown-multiselect formControlName="packageTypes"
                                                      [items]="packageOptions"
                                                      placeholder="Select package types">
                            </nuc-dropdown-multiselect>
                        </nuc-form-field>

                        <div class="custom-packages">
                            <h2>Custom packages</h2>
                            <p>Optional, add one or more custom packages</p>
                            <hr>
                            <div class="custom-package"
                                 *ngFor="let customPackageForm of optionsFormGroup.controls[control.key].controls['customPackages'].controls; let index = index">
                                <div class="custom-package-title">
                                    <p>Custom package #{{ index + 1 }}</p>
                                    <nuc-button-secondary icon="nucicon_trash_fill" class="delete-button"
                                                          (click)="deleteCustomPackage(index)">
                                    </nuc-button-secondary>
                                </div>
                                <workflow-configuration-action-custom-package-form
                                    [formGroup]="customPackageForm"
                                    [scaleTypes]="scaleTypes"
                                    [formatOptions]="formatOptions">
                                </workflow-configuration-action-custom-package-form>
                            </div>

                            <nuc-button-bar>
                                <nuc-button-secondary text="Add custom package" icon="nucicon_add" iconPosition="end" (click)="addCustomPackageFormGroup()"></nuc-button-secondary>
                            </nuc-button-bar>
                        </div>

                    </div>

                    <div *ngSwitchCase="EWorkflowActionOptionName.NOTIFICATION">
                        <div class="boolean-field">
                            <nuc-form-field label="Send notifications"></nuc-form-field>
                            <!--text and textPosition is used to fix styling-->
                            <nuc-checkbox [formControl]="optionsFormGroup.controls[control.key].controls['sendNotifications']" text=" " textPosition="start"></nuc-checkbox>
                        </div>
                        <workflow-configuration-action-notification-form
                            *ngIf="optionsFormGroup.controls[control.key].controls['notificationData']"
                            [noteToStatus]="noteToStatus"
                            [campaignItemFieldOptions]="displayOptions"
                            [initialValue]="notificationOptionValue"
                            [formGroup]="optionsFormGroup.controls[control.key].controls['notificationData']">
                        </workflow-configuration-action-notification-form>
                    </div>

                    <div *ngSwitchCase="EWorkflowActionOptionName.REMOVE_SIGN_OFFS">
                        <nuc-form-field label="Choose what will be done with publication item approvals when creating a sticky note">
                            <nuc-dropdown [formControlName]="control.key"
                                          [items]="signOffOptions"
                                          [nullOption]="false"
                                          placeholder="Select an option">
                            </nuc-dropdown>
                        </nuc-form-field>
                    </div>

                    <div *ngSwitchCase="EWorkflowActionOptionName.CHANNEL" class="dropdown-field">
                        <nuc-form-field label="Filter by channel">
                            <nuc-dropdown [formControlName]="control.key"
                                          [total]="channels.length"
                                          [items]="channels"
                                          placeholder="Select a channel">
                            </nuc-dropdown>
                        </nuc-form-field>
                    </div>

                    <div *ngSwitchCase="EWorkflowActionOptionName.ENGINE_TYPES" class="dropdown-field">
                        <nuc-form-field label="Filter by engine types">
                            <nuc-dropdown-multiselect [formControlName]="control.key"
                                                      [items]="engineTypes"
                                                      placeholder="Select engine type(s)">
                            </nuc-dropdown-multiselect>
                        </nuc-form-field>
                    </div>

                    <div *ngSwitchCase="EWorkflowActionOptionName.TEMPLATE_FILTER_CAMPAIGN_TAGS" class="boolean-field">
                        <nuc-form-field label="Filter by campaign tags"></nuc-form-field>
                        <!--text and textPosition is used to fix styling-->
                        <nuc-checkbox [formControlName]="control.key" text=" " textPosition="start"></nuc-checkbox>
                    </div>

                    <div *ngSwitchCase="EWorkflowActionOptionName.TEMPLATE_FILTER_TEMPLATE_TAGS" class="dropdown-field">
                        <nuc-form-field label="Filter by template tags">
                            <nuc-dropdown-multiselect [formControlName]="control.key"
                                                      [items]="templateTagsOptions"
                                                      placeholder="Select template tag(s)">
                            </nuc-dropdown-multiselect>
                        </nuc-form-field>
                    </div>

                    <div *ngSwitchCase="EWorkflowActionOptionName.TEMPLATE_FILTER_TEMPLATE_TYPES" class="dropdown-field">
                        <nuc-form-field label="Filter by template types">
                            <nuc-dropdown-multiselect [formControlName]="control.key"
                                                      [items]="templateTypeOptions"
                                                      placeholder="Select template type(s)">
                            </nuc-dropdown-multiselect>
                        </nuc-form-field>
                    </div>

                    <div *ngSwitchCase="EWorkflowActionOptionName.REQUIRED_FILES" class="dropdown-field">
                        <nuc-form-field label="Required files">
                            <nuc-dropdown-multiselect [formControlName]="control.key"
                                                      [items]="requiredFilesOptions"
                                                      placeholder="Select which files are required to upload">
                            </nuc-dropdown-multiselect>
                        </nuc-form-field>
                    </div>
                </ng-container>
            </ng-container>
        </form>
    </div>
</form>

<ng-template #loadingIndicator>
    <rl-loading-indicator size="large"></rl-loading-indicator>
</ng-template>
